// URL base del backend.
// Default: produzione su Render. In sviluppo si sovrascrive con la variabile
// d'ambiente REACT_APP_API_URL (es. REACT_APP_API_URL=http://localhost:8000 npm start).
export const API_BASE =
  process.env.REACT_APP_API_URL || "https://hedone-backend.onrender.com";
